import React, { useState } from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { FAQS, NEWS } from './data';
import { noTranslate } from './formatters';

/** 한 페이지에 보여줄 소식 건수 — 목록 높이를 이 수에 맞춰 고정한다. */
const PAGE_SIZE = 4;

/** 시안 #faq — 좌측 FAQ 아코디언 + 우측 새로운 소식(4건씩 페이지 넘김) */
const FaqNotice = () => {
  const [open, setOpen] = useState(0);
  const [page, setPage] = useState(0);

  const pageCount = Math.max(1, Math.ceil(NEWS.length / PAGE_SIZE));
  const shown = NEWS.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);
  // 마지막 페이지가 비어도 높이가 줄지 않도록 빈 칸을 채운다.
  const blanks = PAGE_SIZE - shown.length;

  return (
    <section className={`${p.splitGrid} ${p.reveal}`}>
      <div>
        <div className={p.badge} translate="no">FAQ</div>
        <h2 className={p.titleMd}>
          궁금한 점을
          <br />
          먼저 정리했습니다
        </h2>

        <div className={p.faqList}>
          {FAQS.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div className={p.faqItem} key={faq.q}>
                <button
                  type="button"
                  className={p.faqBtn}
                  translate={noTranslate(faq.q)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span className={p.faqNo}>{i + 1}</span>
                  {faq.q}
                  <span
                    className={`${p.faqMark} ${isOpen ? p.faqMarkOpen : ''}`}
                    aria-hidden="true"
                  >
                    ▾
                  </span>
                </button>
                {isOpen ? (
                  <p className={p.faqAnswer} id={`faq-answer-${i}`} translate={noTranslate(faq.a)}>
                    {faq.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>

      <div>
        <div className={p.badge} translate="no">NOTICE</div>

        <div className={p.noticeHead}>
          <h2 className={p.titleMd}>새로운 소식</h2>

          {pageCount > 1 ? (
            <div className={p.pager}>
              <button
                type="button"
                className={p.pagerBtn}
                onClick={() => setPage((n) => n - 1)}
                disabled={page === 0}
                aria-label="이전 소식"
              >
                ‹
              </button>
              <span className={p.pagerNow}>
                {page + 1} / {pageCount}
              </span>
              <button
                type="button"
                className={p.pagerBtn}
                onClick={() => setPage((n) => n + 1)}
                disabled={page === pageCount - 1}
                aria-label="다음 소식"
              >
                ›
              </button>
            </div>
          ) : null}
        </div>

        <div className={p.noticeList}>
          {shown.map((item) => (
            <div className={p.noticeCard} key={item.title}>
              <div className={p.noticeTitle} translate={noTranslate(item.title)}>{item.title}</div>
              <div className={p.noticeDate}>{item.date}</div>
            </div>
          ))}
          {Array.from({ length: blanks }, (_, i) => (
            <div className={p.noticeCard} key={`blank-${i}`} aria-hidden="true" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqNotice;
